<template>
  <el-upload
    :disabled="disabled"
    ref="uploadForm"
    class="upload-demo"
    :limit="limit"
    :action="uploadUrl"
    :on-preview="previewFun"
    :on-remove="removeFun"
    :headers="{Accept:'application/json, text/plain, */*'}"
    :with-credentials="true"
    :http-request="httpRequest"
    :file-list="self_list">
    <el-button :disabled="disabled" size="small" type="primary">点击上传</el-button>
    <div slot="tip" v-if="!disabled" class="el-upload__tip">只能上传文件，不超过20个文件</div>
  </el-upload>
</template>

<script>
import axios from "axios";

export default {
  name: "UploadFilesSysc",
  props:{
    list:String,
    hostUrl:String,
    uploadUrl:{
      type:String,
      default(){
        return ""
      }
    },
    limit:{
      type:Number,
      default(){
        return 1
      }
    },
    disabled:{
      type:Boolean,
      default(){
        return false
      }
    },
  },
  model: {
    prop: "list", // 定义传递给v-model的那个变量，绑定到哪个属性值上               (默认值value)
    event: "success", // event:什么时候触发v-model行为(让父组件能获取到值)    (默认值input)
  },
  data(){
    return {
      self_list:[],
    }
  },
  created() {
    var that=this;
    this.onListIn();
  },
  methods:{
    onListIn(){
      var that=this;
      if(that.list){
        that.self_list=JSON.parse(this.list)
      }else {
        that.self_list=[];
      }
    },
    removeFun(file, fileList){
      this.self_list=fileList
      this.$emit("success",JSON.stringify(this.self_list))
    },
    previewFun(file){
      window.open(file.url);
    },
    httpRequest(item){
      var that=this;
      let formData = new FormData();
      formData.append("file",item.file);
      axios.post(item.action,formData).then(res=>{
        if(res && res.data && res.data.data){
          item=res.data.data;
          item.url=item.path
          // 保存完整的文件信息，包括 md5、size 等
          const fileInfo = {
            uid: item.uid || 0,
            file_dir: item.file_dir || '',
            md5: item.md5 || '',
            type: item.type || '',
            path: item.path || '',
            name: item.name || '',
            size: item.size || 0,
            url: that.$url(item.path)
        }
          that.self_list.push(fileInfo)
          // 传递完整的文件信息列表
          this.$emit("success",JSON.stringify(that.self_list))
        }
      },err=>{
        // that.clearFlies()
      })
    },
    clearFlies() {
      this.$refs.uploadForm.clearFiles();
    },
    $url(url){
      return this.hostUrl+"/"+url;
    }
  },
  watch:{
    list(n){
      this.onListIn();
    }
  }
}
</script>

<style lang="scss" scoped>
@import url(../common.scss);
.file-fm{
  justify-content: space-between;
  width: 300px;
  .file-fm-rt{
    width: 70px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Contract/components/UploadFilesSysc.vue